import PropTypes from 'prop-types'
import React from 'react'

const DEFAULT_CIRCLE = {
  stroke: 'currentColor',
  strokeWidth: '6px',
  fill: 'none',
}
const DEFAULT_DOT = {
  fill: 'currentColor',
}

const RadioSVG = ({ size, circle, dot, checked }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 100 100"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title>Radio</title>
    <g id="Circle" {...DEFAULT_CIRCLE} {...circle}>
      <circle cx="50" cy="50" r="45" />
    </g>
    {checked && (
      <g id="Dot" {...DEFAULT_DOT} {...dot}>
        <circle cx="50" cy="50" r="20" />
      </g>
    )}
  </svg>
)

RadioSVG.defaultProps = {
  size: 24,
  circle: {},
  dot: {},
  checked: false,
}

RadioSVG.propTypes = {
  size: PropTypes.number,
  circle: PropTypes.shape({}),
  dot: PropTypes.shape({}),
  checked: PropTypes.bool,
}

export default RadioSVG
